
// import ReduceCost from '../../../Assets/Dicount-GIF/reduce-cost.gif';
import coupon from '../../../Assets/Discount-GIF/coupon.gif';
import Reducecost from '../../../Assets/Discount-GIF/reduce-cost.gif';
import Sales from '../../../Assets/Discount-GIF/sales (1).gif';
import Sales2 from '../../../Assets/Discount-GIF/sales.gif';
import shoe from '../../../Assets/Discount-GIF/shoe.gif';
import Shoppingbag from '../../../Assets/Discount-GIF/shopping-bag.gif';
import Discount from '../../../Assets/Discount-GIF/discount.gif';

// showes
import Puma from '../../../Assets/Discount-GIF/Discount_images/puma-logo-black.jpg';
import adidas from '../../../Assets/Discount-GIF/Discount_images/adidas_black.png';
import Nike from '../../../Assets/Discount-GIF/Discount_images/Nike.jpg';
import UnderArmour from '../../../Assets/Discount-GIF/Discount_images/Under_armour_black.png';
import woodland from '../../../Assets/Discount-GIF/Discount_images/woodland-logo-woodland-blackwhite.webp';
import Bata from '../../../Assets/Discount-GIF/Discount_images/bata_logo_black.webp';
import Reebok from '../../../Assets/Discount-GIF/Discount_images/wallpapersden.com_reebok-black.jpg';
import converse from '../../../Assets/Discount-GIF/Discount_images/Converse_(shoe_company)-black.png';

// mobile brands

import Samsung from '../../../Assets/Discount-GIF/Discount_images/Samsung.jpg';
import mi from '../../../Assets/Discount-GIF/Discount_images/mi-logo.png';
import Apple from '../../../Assets/Discount-GIF/Discount_images/Apple.png';
import moto from '../../../Assets/Discount-GIF/Discount_images/motorola-logo.png';
import vivo from '../../../Assets/Discount-GIF/Discount_images/vivo-communication.png';
import Realme from '../../../Assets/Discount-GIF/Discount_images/Realme.jpg';

// laptop 
import Hp from '../../../Assets/Discount-GIF/Discount_images/HP-Logo.png';
import dell from '../../../Assets/Discount-GIF/Discount_images/Dell_Logo.png';
import lenovo from '../../../Assets/Discount-GIF/Discount_images/Lenovo_Global_Corporate_Logo.png';
import Mac from '../../../Assets/Discount-GIF/Discount_images/macbook-air-logo.png';
import Acer from '../../../Assets/Discount-GIF/Discount_images/Acer-Logo.png';
import Asus from '../../../Assets/Discount-GIF/Discount_images/hd-asus.png';
import Modal from '@mui/material/Modal';
import { Box, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { Margin } from '@mui/icons-material';
import { BrandDetails } from '../../../config/Discount_constant';
import QRCode from 'qrcode.react';
import CloseIcon from "@mui/icons-material/Close";
import ExportIcon from '../../../Assets/Discount-GIF/Discount_images/export.png';
import Info from '../../../Assets/Discount-GIF/Discount_images/Info.png';

const style = {
    position: 'absolute',
    top: '35%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    // height: 350,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    // margin:20,
};

const Couponstyle = {
    position: 'absolute',
    top: '45%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    // height: 350,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    // margin:20,
};

const ParentDiscount = () => {
    const [openModal, setOpenModal] = useState(false);
    const [selectedItem, setSelectItem] = useState("");
    const [openCoupon, setOpenCoupon] = useState(false);

    const [completeCouponData, setCompleteCouponData] = useState("");
    console.log("Brand Details", BrandDetails);

    const filterData = BrandDetails.find(item => item.brand === selectedItem.name);

    // console.log("Filtered data--------------", filterData, "filterData.offers---------", filterData?.offers, "selectedItem---", selectedItem.name);


    const handleOpen = (selectedvalue) => {
        setOpenModal(true);
        setSelectItem(selectedvalue);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleShowCompleteCoupon = (data) => {

        setCompleteCouponData(data);
        setOpenModal(false);
        setOpenCoupon(true);
    };
    console.log("Complete data", completeCouponData);

    const gifs = [coupon, Shoppingbag, Sales, Sales2, shoe, Reducecost, Discount];
    const showesbrand = [{ img: adidas, name: "Adidas" }, { img: Nike, name: "Nike" }, { img: UnderArmour, name: "UnderArmour" }, { img: woodland, name: "Woodland" }, { img: Bata, name: "Bata" }, { img: Reebok, name: "Reebok" }, { img: converse, name: "Converse" }, { img: Puma, name: "Puma" }];
    const Mobiles = [{ img: Samsung, name: 'Samsung' }, { img: mi, name: "MI" }, { img: Apple, name: "Apple" }, { img: moto, name: "Motorola" }, { img: vivo, name: "Vivo" }, { img: Realme, name: "Realme" }, { img: mi, name: "MI" }];
    const laptops = [{ img: Hp, name: "Hp" }, { img: dell, name: "Dell" }, { img: lenovo, name: "Lenovo" }, { img: Acer, name: "Acer" }, { img: Asus, name: "Asus" }, { img: Mac, name: "MackAir" }, { img: dell, name: 'Dell' }];

    return (
        <div className="home-page-container w-100 h-100 flex flex-column justify-content-center align-items-center p-3">
            <div className="d-flex flex-column bg-white rounded">
                <div className='d-flex alig-items-start justify-contetnt-start p-3'>
                    <p className='fw-semibold fs-4'>Discounts</p>
                </div>

                <div className='d-flex justify-content-center align-items-center gap-5 p-3 pb-5'>
                    {gifs.map((values, index) =>
                        <div key={index} style={{
                            border: "1px solid gray",
                            borderRadius: "40px",
                            width: "80px",
                            height: "80px",
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer"
                        }}>
                            <img
                                src={values}
                                alt="GIF"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        </div>
                    )}
                </div>


                <div className='d-flex flex-column justify-content-center align-items-center py-3 px-3' style={{ backgroundColor: "#E5E4E2" }}>
                    <Box className="w-100 d-flex flex-column justify-content-center align-items-start ps-5">
                        <h6 className='fw-bold'>Mobiles</h6>
                    </Box>

                    <div style={{
                        width: "90%",
                        overflowX: "auto",
                        overflowY: "hidden",
                        whiteSpace: "nowrap",  // <- this makes it scroll
                        boxSizing: "border-box",
                        display: "flex",
                        scrollbarWidth: "none"
                    }}>
                        {Mobiles.map((value, index) =>

                            <div className="bg-white p-5 m-1" style={{ cursor: "pointer", }} onClick={() => handleOpen(value)}>
                                <img src={value.img} key={index} alt="puma" width="100" height="100" style={{ objectFit: "contain", backgroundColor: "#ffffff" }} />
                            </div>
                        )}
                    </div>
                </div>

                <div className='d-flex flex-column justify-content-center align-items-center py-3' style={{
                    backgroundColor: "#E5E4E2",
                    width: "100%"
                }}>
                    <Box className="w-100 d-flex flex-column justify-content-center align-items-start ps-5">
                        <h6 className='fw-bold'>Showes</h6>
                    </Box>
                    <div style={{
                        width: "90%",
                        overflowX: "auto",
                        overflowY: "hidden",
                        whiteSpace: "nowrap",  // <- this makes it scroll
                        boxSizing: "border-box",
                        display: "flex",
                        scrollbarWidth: "none"      // <- make it flex row
                    }}>
                        {showesbrand.map((value, index) => (
                            <div key={index} className="bg-white p-5 m-1" style={{
                                cursor: "pointer",
                                flexShrink: 0          // <- prevent items from shrinking
                            }} onClick={() => handleOpen(value)}>
                                <img
                                    src={value.img}
                                    alt="brand"
                                    width="100"
                                    height="100"
                                    style={{
                                        objectFit: "contain",
                                        backgroundColor: "#ffffff"
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className='d-flex flex-column justify-content-center align-items-center py-3' style={{ backgroundColor: "#E5E4E2", }}>
                    <Box className="w-100 d-flex flex-column justify-content-center align-items-start ps-5">
                        <h6 className='fw-bold'>Laptops</h6>
                    </Box>
                    <div style={{
                        width: "90%",
                        overflowX: "auto",
                        overflowY: "hidden",
                        whiteSpace: "nowrap",  // <- this makes it scroll
                        boxSizing: "border-box",
                        display: "flex",
                        scrollbarWidth: "none"      // <- make it flex row
                    }}>
                        {laptops.map((value, index) =>
                            <div className="bg-white p-5 m-1" style={{ cursor: "pointer" }} onClick={() => handleOpen(value)}>
                                <img src={value.img} key={index} alt="puma" width="100" height="100" style={{ objectFit: "contain", backgroundColor: "#ffffff" }} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={style}>
                    <p className='fw-semibold px-3 mt-3'>Coupons</p>

                    {filterData?.offers.map((items, index) =>
                        <Box key={index} className="d-flex flex-row justify-content-start align-items-center py-1 my-3 gap-2 px-3 rounded" style={{ backgroundColor: "#D3D3D3", marginLeft: "100px", marginRight: "100px", cursor: "pointer" }} onClick={() => handleShowCompleteCoupon(items)}>
                            <Box className="py-2" >
                                <img src={selectedItem?.img} width="70" height="60" alt={selectedItem?.img} />
                            </Box>
                            <Box style={{ height: "70px", borderLeft: "2px dashed #555" }} className='pe-3'></Box>
                            <Box className="d-flex flex-column align-items-start justify-content-start py-2">
                                <span className='fw-bold'>{items?.discount}</span>
                                <span className='fw-bold' style={{ fontSize: "14px" }}>{selectedItem?.name}</span>
                                <span className="pt-3" style={{ color: "#666666", fontSize: "12px" }}>Valid until {items?.valid_until}</span>
                            </Box>
                        </Box>)}
                </Box>
            </Modal>

            <Modal
                open={openCoupon}
                // onClose={() => setOpenCoupon(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box sx={Couponstyle}>
                    <Box className="d-flex flex-row justify-content-between align-items-center px-3">
                        <Box>
                            <p className='fw-semibold px-3 mt-3'>Coupon Details</p>
                        </Box>
                        <Box>
                            <IconButton onClick={() => setOpenCoupon(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                    </Box>

                    <Box className="d-flex flex-column justify-content-center align-items-center pb-2">
                        <Box
                            className="d-flex flex-column justify-content-center align-items-center m-2 rounded"
                            style={{ backgroundColor: "#D3D3D3", width: "75%" }}
                        >
                            <Box className="w-75 d-flex flex-row justify-content-between rounded my-2" style={{ backgroundColor: "#D3D3D3", cursor: "pointer" }}>
                                <Box className="py-3" >
                                    <img src={selectedItem?.img} width="70" height="60" alt={selectedItem?.img} />
                                </Box>
                                {/* <Box style={{ height: "70px", borderLeft: "2px dashed #555" }} className='pe-3'></Box> */}
                                <Box className="d-flex flex-column align-items-center justify-content-center py-3">
                                    <span className='fw-bold'>{completeCouponData?.discount} OFF</span>
                                    <span className='fw-normal' style={{ fontSize: "14px" }}>{selectedItem?.name}</span>
                                    {/* <span className="pt-3" style={{ color: "#666666", fontSize: "12px" }}>Valid until {completeCouponData?.valid_until}</span> */}
                                </Box>

                            </Box>

                            <Box className="d-flex flex-column justify-content-start align-items-start p-2 m-2">
                                <p className='fw-bold'>Get {completeCouponData?.discount} at your next {selectedItem?.name} Buy</p>
                                {completeCouponData?.Policy?.map((value, index) =>

                                    <Box key={index} className="d-flex flex-column justify-content-start align-items-start">
                                        <h6>{value}</h6>
                                    </Box>
                                )}

                            </Box>
                            <Box style={{ width: "92%", height: "1px", borderTop: "2px dashed #555" }}></Box>

                            <Box className="d-flex flex-column align-items-center justify-content-center py-3">
                                <QRCode
                                    className="container-gift-2"
                                    value={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=}`}
                                    style={{ height: "96px", width: "96px" }}
                                />
                                <Box className="w-100 d-flex flex-row align-items-center justify-content-between gap-5">
                                    <img src={ExportIcon} alt='Export icon' width="20" height="20" className='me-5' />
                                    <p className="pt-3" style={{ color: "#666666", fontSize: "12px" }}>Valid until {completeCouponData?.valid_until}</p>
                                    <img src={Info} alt="Information" width="20" height="20" className='ms-5' />
                                </Box>

                            </Box>
                        </Box>
                    </Box>

                </Box>
            </Modal>
        </div >
    );
};

export default ParentDiscount;